const Constants = {
  graphql_backend_url: process.env.VUE_APP_BACKEND_GRAPHQL_URL,
  api_url: process.env.VUE_APP_API_URL,
  base_url: process.env.VUE_APP_BASE_URL,
  razorPayKey: process.env.VUE_APP_RAZOR_PAY_KEY,
  razorpay_url: 'https://ifsc.razorpay.com/',
  approvedStageId: '245eeacc-ceb2-4108-b281-1ce86a12cf02',
  reviewStageId: '7924c398-ad44-4485-b880-92ef34915c5b',
  newStageId: 'b95d8bc8-1aa8-4acb-8c44-ed4940148155',
  docPending: 'e31246ae-9b12-457d-9145-ec45cb6a341e',
  rejectedId: '6cf4590a-cc2c-49a7-95df-a25e0d5972c0',
  rejectedId1: 'a5b3ba99-0b34-494a-be50-5a65933170d2',
  rejectedId2: '21588a41-9758-4590-820f-4c22c580c7ff',
  rejectedId3: 'fa00bd31-a725-403b-9951-93aacb014033',
  rejectedId4: 'd0b06f6c-5e71-4e06-8e1c-b82e42f6207b',
  VAD: '3260ebcf-8944-4dc1-a003-9997b0e07811',
  VAP: '921a8e09-766f-4894-b04c-495059858bb4',
  VP: '967c4293-e850-4191-9997-75fb37cce656',
  RD: '917370fd-9532-4f84-bd30-9b6f0777e206',
  RP: '7a1653b8-7981-4405-a3d3-e3a3e38948ad',
  ND: '9260ebcf-8944-4dc1-a003-9997b0e07811',
  containsObject: function (obj, list) {
    for (var i = 0; i < list.length; i++) {
      if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
        return true
      }
    }
    return false
  },
  UserTypes: {
    Accountant: '35c5dd72-5b77-422d-a08d-adc5f0f6cb32',
    Sales: '03185af3-fd06-42cb-91d9-b8081ee1f704',
    Executive: '8aa7ad16-eaf1-44af-93c0-16ea23203490',
    Helpdesk: '0c3b4b3b-8b36-4e2e-9b17-6c55fa96dae2',
    SupportEngineer: '61e76d2a-0c25-4d1c-9d05-4cf4f64ea411',
    SupportManager: '78dca28e-50f7-4f6f-b3fa-197a5a44e002',
    PartnerOwner: '1005d5ea-3e59-4108-a6f9-c5782ec73f4a',
  },
  SupportStatuses: {
    New: 'f031966c-01b1-4bde-9873-f862228adf50',
    InProgress: 'a8420bad-2b8f-4a91-b641-30d0b8380bb8',
    OnHold: 'c7251acd-5117-4238-8fb5-1f81b73a6718',
    WaitForCustomerResponse: 'dd2b4db0-9fef-410b-abb4-e395601170b8',
    Solved: '59bac54e-db19-4963-9264-82552ca8159d',
    Rejected: '07dc9cc1-10a4-4e3d-b3ed-20f32dc4f491',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyAIUClXjZOj3hR84oGsopQopwQzLjbXcU0',
    authDomain: 'aipl-250310.firebaseapp.com',
    databaseURL: 'https://aipl-250310.firebaseio.com',
    projectId: 'aipl-250310',
    storageBucket: 'aipl-250310.appspot.com',
    messagingSenderId: '119566062323',
    appId: '1:119566062323:web:cd1afa3e1caae5a8479d86',
    measurementId: 'G-CB5JYY5JDT',
  },
  notificationTimeout: 5000,
  notificationLimitPerBatch: 20,
  AIPL_ORGID: '60bb56a3-bea4-4edd-906c-d1879ce12ea1',
  AIPL_PARTNER: {
    id: process.env.VUE_APP_PARTNER_ID,
    name: process.env.VUE_APP_PARTNER_NAME,
    partnerCode: process.env.VUE_APP_PARTNER_CODE,
  },
  DEFAULT_SUPPORT_PLAN: {
    id: '016e5c7b-8f40-48b5-b0db-dd4041aeee1a',
    name: 'Telephonic Plan', duration: 1825,
  },
  ORDER_TYPES: {
    SALES: 1,
    RETAIL_SALES: 2,
    RETURN_ORDER: 3,
    RETAIL_SALES_FORTINET: 4,
  },
  OEMId:{
    ESET: '42285666-0fd1-837e-7911-60717ec371a1',
    FORTINET: 'd2ea3e4a-3cc0-9d3f-594e-8efb5edbd168',
  },
  GstPattern: /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[Zz]{1}[0-9A-Za-z]{1}$/,
  PanPattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/,
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }
}

export const OEMIdToOrderType = {
  [Constants.OEMId.ESET]: Constants.ORDER_TYPES.RETAIL_SALES,
  [Constants.OEMId.FORTINET]: Constants.ORDER_TYPES.RETAIL_SALES_FORTINET,
}

export default Constants
